export function getMerchantImage(merchant, size = 'sm') {
  const SIZE_MAP = {
    xs: 'thumbnail',
    sm: 'small',
    md: 'med',
    lg: 'large',
  };
  return merchant.images?.[0]?.[`image_${SIZE_MAP[size]}`];
}
